import { AttackRange, DamageType, ItemRarity, Weapon } from 'game/core'
import { ItemUI } from 'game/extended/uis/item_uis'

import image from './epic_wand.png'

export const epic_wand: ItemUI<Weapon> = {
    image,
    label: 'Epic wand',
    value: 250,
    item: {
        key: 'epic_wand',
        type: 'weapon',
        rarity: ItemRarity.Epic,
        stats: {
            intelligence: 75,
            health: 60,
            shielding: 25,
            resistance: 25,
            energy: 2
        },
        two_handed: true,
        category: 'wand',
        damageType: DamageType.Magic,
        range: AttackRange.Mixed,
        energy: 4,
        damage: 12
    }
}
